export default __webpack_public_path__ + "static/media/shared.01ff43af.png";